import { render, staticRenderFns } from "./CreateCreative.vue?vue&type=template&id=bbe77566&scoped=true"
import script from "./CreateCreative.vue?vue&type=script&lang=js"
export * from "./CreateCreative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe77566",
  null
  
)

export default component.exports